import React, { memo, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Slider from "react-slick";
import toast from "react-hot-toast";

const NewArrivalTwo = () => {
  const [relatedProducts, setRelatedProducts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetch("/assets/data/products.json")
      .then((res) => res.json())
      .then((data) => {
        const shuffled = [...data].sort(() => 0.5 - Math.random());
        setRelatedProducts(shuffled.slice(0, 10));
      })
      .catch((err) => console.error("Failed to load products:", err));
  }, []);

  const handleAddToCart = (product) => {
    const isLoggedIn = sessionStorage.getItem("isLoggedIn");

    if (isLoggedIn !== "true") {
      toast.error("Please login first!");
      navigate("/login");
      return;
    }

    let cart = JSON.parse(sessionStorage.getItem("cart")) || [];
    const existing = cart.find((item) => item.id === product.id);

    if (existing) {
      existing.quantity += 1;
    } else {
      cart.push({ ...product, quantity: 1 });
    }

    sessionStorage.setItem("cart", JSON.stringify(cart));
    toast.success(`${product.name} added to cart!`);
  };

  const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 6,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1599,
        settings: {
          slidesToShow: 6,
        },
      },
      {
        breakpoint: 1399,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 424,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <section className="new-arrival pb-80">
      <div className="container container-lg">
        <div className="section-heading">
          <div className="flex-between flex-wrap gap-8">
            <h5 className="mb-0">You Might Also Like</h5>
          </div>
        </div>
        <div className="new-arrival__slider arrow-style-two">
          <Slider {...settings}>
            {relatedProducts.map((item) => {
              const rating = (Math.random() * 1 + 4).toFixed(1);
              const reviews = Math.floor(Math.random() * 24000 + 1000);
              const total = 100;
              const sold = Math.floor(Math.random() * total);
              const percent = (sold / total) * 100;

              return (
                <div key={item.id}>
                  <div
                    style={{
                      background: "#fff",
                      borderRadius: "20px",
                      padding: "18px",
                      boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
                      border: "1px solid #f1f1f1",
                      transition: "all 0.3s ease",
                      cursor: "pointer",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.transform = "translateY(-6px)")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.transform = "translateY(0)")
                    }
                  >
                    {/* IMAGE */}
                    <Link
                      to={`/product/${item.id}`}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        background: "#fafafa",
                        borderRadius: "16px",
                        padding: "20px",
                      }}
                    >
                      <img
                        src={
                          item.imageUrl ||
                          "/assets/images/thumbs/product-two-img1.png"
                        }
                        alt={item.name}
                        style={{
                          width: "80%",
                          height: "auto",
                          objectFit: "contain",
                        }}
                      />
                    </Link>

                    {/* TITLE */}
                    <h6
                      style={{
                        fontSize: "15px",
                        fontWeight: 700,
                        marginTop: "14px",
                        color: "#111",
                        lineHeight: "1.4",
                        height: "42px",
                        overflow: "hidden",
                      }}
                    >
                      <Link
                        to={`/product/${item.id}`}
                        style={{ textDecoration: "none", color: "#111" }}
                      >
                        {item.name}
                      </Link>
                    </h6>

                    {/* RATING */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                        fontSize: "13px",
                        marginBottom: "8px",
                      }}
                    >
                      <span style={{ color: "#444", fontWeight: 600 }}>
                        {rating}
                      </span>
                      <i
                        className="ph-fill ph-star"
                        style={{ color: "#ffb400" }}
                      />
                      <span style={{ color: "#888" }}>
                        ({reviews.toLocaleString()} reviews)
                      </span>
                    </div>

                    {/* SOLD BAR */}
                    <div style={{ marginTop: "10px" }}>
                      <div
                        style={{
                          height: "5px",
                          width: "100%",
                          background: "#eee",
                          borderRadius: "10px",
                          overflow: "hidden",
                        }}
                      >
                        <div
                          style={{
                            height: "100%",
                            width: `${percent}%`,
                            background: "#2694e9",
                          }}
                        />
                      </div>
                      <span
                        style={{
                          fontSize: "12px",
                          color: "#555",
                          marginTop: "6px",
                          display: "block",
                          fontWeight: 600,
                        }}
                      >
                        Sold: {sold}/{total}
                      </span>
                    </div>

                    {/* PRICE */}
                    <div style={{ margin: "14px 0" }}>
                      {item.oldPrice && (
                        <span
                          style={{
                            textDecoration: "line-through",
                            color: "#999",
                            marginRight: "6px",
                          }}
                        >
                          ${item.oldPrice}
                        </span>
                      )}

                      <span
                        style={{
                          fontSize: "20px",
                          fontWeight: 700,
                          color: "#111",
                        }}
                      >
                        ${item.price}
                      </span>
                      <span style={{ color: "#777", fontSize: "13px" }}>
                        {" "}
                        /Qty
                      </span>
                    </div>

                    {/* ADD TO CART BTN */}
                    <button
                      onClick={() => {
                        handleAddToCart(item);
                        window.location.reload();
                      }}
                      style={{
                        width: "100%",
                        background: "#111",
                        color: "#fff",
                        padding: "12px 0",
                        borderRadius: "10px",
                        border: "none",
                        fontWeight: 600,
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "8px",
                        transition: "0.3s",
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.background = "#000")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.background = "#111")
                      }
                    >
                      Add To Cart <i className="ph ph-shopping-cart" />
                    </button>
                  </div>
                </div>
              );
            })}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default memo(NewArrivalTwo);
